module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/J02oJV/tc-custom/9781644031780.jpg?1732163600206",
      "alt": "This image is the cover for the book Show Me How to Paper Piece"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Show Me How to Paper Piece\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Quick & easy and paper-piecing method! Learn the basics of paper-piecing with renowned teacher Carol Doak. Beginners leap into quilting and create your first paper-pieced quilt with thorough instructions and guided visuals to help achieve a perfect, accurate block. Create your own wall quilt by sewing blocks that can be completed in 3 simple steps! Step-by-step instructions for perfect blocks every time  Guided by expert quilter and best-selling author Carol Doak Easy for all skill levels! First-time quilters can achieve accurate blocks")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carol Doak\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carol Doak is a pioneer in the area of paper foundation piecing. She has published over a dozen successful books and earned many honors in the quilting industry. Carol lives in Bonita Springs, Florida. caroldoak.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Published by C&T Publishing, Inc.,\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0